import { render } from "./TopicOverview.vue?vue&type=template&id=faecea18&scoped=true"
import script from "./TopicOverview.vue?vue&type=script&lang=js"
export * from "./TopicOverview.vue?vue&type=script&lang=js"

import "./TopicOverview.vue?vue&type=style&index=0&id=faecea18&scoped=true&lang=css"
import "./TopicOverview.vue?vue&type=style&index=1&id=faecea18&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faecea18"]])

export default __exports__